<script lang="ts">
	import { onMount } from 'svelte';
	import FooterNav from './nav/FooterNav.svelte';
	import LegalNav from './nav/LegalNav.svelte';
	import Social from '$lib/components/Social.svelte';
	import Newsletter from './Newsletter.svelte';
	import { richTextToHTML } from '@app/utils/cms';
	import { bottomNavbarHeight } from '@app/stores/bottomNavbar';

	export let classNames = '';

	let story;
	let socialItems = [
		{
			iconName: 'twitter',
			url: 'https://twitter.com/wiseed'
		},
		{
			iconName: 'facebook',
			url: 'http://www.facebook.com/wiseed'
		},
		{
			iconName: 'linkedin',
			url: 'https://www.linkedin.com/company/wiseed'
		},
		{
			iconName: 'instagram',
			url: 'https://www.instagram.com/wiseed_com/'
		},
		{
			iconName: 'youtube',
			url: 'http://www.youtube.com/user/wiseedfrance'
		}
	];

	onMount(async () => {
		try {
			const res = await fetch('/cms/footer');
			const json = await res.json();
			if (res.ok) {
				story = json;
			}
		} catch (e) {
			console.error(e);
		}
	});
</script>

<footer class="{classNames} bg-dashboardBg" style={`padding-bottom: ${$bottomNavbarHeight}px`}>
	<section class="relative pt-4 md:pt-6 z-0">
		<div class="container">
			<Newsletter />
		</div>
	</section>
	<section>
		<div
			class="container space-y-4 md:space-y-0 md:grid md:grid-cols-3 lg:grid-cols-4 2xl:grid-cols-5 md:gap-4 xl:gap-4 md:justify-between md:items-start"
		>
			<FooterNav />
			<div
				class="space-x-3 flex md:col-span-2 lg:col-span-4 lg:justify-center 2xl:col-auto 2xl:space-x-2"
			>
				<Social items={socialItems} size="default" color="secondary" />
			</div>
		</div>
	</section>
	<div class="container">
		<div class="border-t border-grey-light"></div>
	</div>
	{#if story}
		<section>
			<div class="container">
				{@html richTextToHTML(story.content.text)}
			</div>
		</section>
	{/if}
	<div class="container">
		<div class="border-t border-grey-light"></div>
	</div>
	<div class="flex flex-col">
		<div class="container py-4">
			<LegalNav classNames="flex flex-col lg:flex-row lg:items-center gap-3 lg:justify-between" />
		</div>
		<div class="text-center py-4 font-semibold">
			2008-{new Date().getFullYear()} WiSEED
		</div>
	</div>
</footer>

<style lang="postcss">
	section {
		@apply py-6;
	}
</style>
